module.exports = __webpack_public_path__ + "static/Recruit04_04-d4c58ebc64da91d11de2aa65e6027df2.png";